module.exports = __webpack_public_path__ + "img/suporte-01.3e1e5ac7.jpg";